module.exports = __webpack_public_path__ + "static/media/report_well_said_white.aed90d42.svg";